// Read Exam Data - Start
export const FETCH_EXAM_DATA_READ_REQUEST = 'FETCH_EXAM_DATA_READ_REQUEST';
export const FETCH_EXAM_DATA_READ_SUCCESS = 'FETCH_EXAM_DATA_READ_SUCCESS';
export const FETCH_EXAM_DATA_READ_FAILURE = 'FETCH_EXAM_DATA_READ_FAILURE';

export const EXPORT_EXAM_DATA_READ_REQUEST = 'EXPORT_EXAM_DATA_READ_REQUEST';
export const EXPORT_EXAM_DATA_READ_SUCCESS = 'EXPORT_EXAM_DATA_READ_SUCCESS';
export const EXPORT_EXAM_DATA_READ_FAILURE = 'EXPORT_EXAM_DATA_READ_FAILURE';
// Read Exam Data End 